module.exports = "/_next/static/images/Functions-854b5a7a492f498383b35e787804f37c.webp";